module.exports = __webpack_public_path__ + "static/img/industry_finance.105a721.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/industry_finance.jpg
// module id = o3WN
// module chunks = 0